import { notSelect } from "../../../styles/general";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const Container = styled.div`
  min-width: 400px;
  height: calc(100vh - 164px);
  min-height: 100%;

  background: #fff;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;

  border-left: 1px solid #eaeaea;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    grid-gap: 8px;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    color: #3e3e3e;
  }

  .link-button {
    font-size: 16px;
    font-weight: 600;
    color: #fb972e;

    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .accordion-button {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;

    border: none;
    background: transparent;

    cursor: pointer;
  }

  .title-button {
    font-size: 16px;
    font-weight: 600;
    color: #3e3e3e;
    /* padding-left: 10px; */
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
`;

export const Circle = styled.div<{ isVisible: boolean }>`
  width: 18px;
  height: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: #fb972e;

  visibility: ${(props) => (props.isVisible === true ? "visible" : "hidden")};

  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  color: #fff;
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;

  padding: 8px;

  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    color: #868482;
  }
`;

export const MainButton = styled.div`
  width: 100%;

  padding: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
`;

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;

  grid-gap: 2px;

  .tag-title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;

    margin-bottom: 16px;
  }

  .flex-item {
    display: flex;
    align-items: center;

    width: 100%;
    height: 35px;

    padding-left: 26px;

    grid-gap: 8px;

    transition: 0.3s background-color;
    cursor: pointer;

    ${notSelect}

    :hover {
      background-color: #f5f5f5;
    }

    .label-circle {
      width: 15px;
      height: 15px;

      margin-right: 5px;
      border-radius: 50%;
      border: 2px solid #707070;
    }

    .chakra-checkbox {
      background-color: #fff !important;
    }
  }
`;

export const LogicButtonsWrapper = styled.div`
  width: calc(100% + 50px);
  height: 40px;

  position: relative;

  margin: 0px -24px 40px;

  border-bottom: 1px solid #eceeee;
`;

export const LogicButtons = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 24px;
`;

export const LogicButton = styled.div<{ isActive: boolean }>`
  width: 120px;
  height: 32px;

  background-color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 600;
  color: #979797;

  border: 1px solid;
  border-color: #cccccc;

  cursor: pointer;
  transition: color 0.3s, border-color 0.3s, opacity 0.3s;

  ${(props) =>
    props.isActive &&
    css`
      color: #fb972e;
      border: 1px solid #fb972e !important;
    `}

  :hover {
    opacity: 0.7;
  }
`;

export const AddCriteriaButton = styled.div`
  /* width: 100%; */

  padding: 20px 0px;

  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #fb972e;

  transition: color 0.3s;
  cursor: pointer;

  :hover {
    color: #fb972e80;
  }
`;

export const SavedSearches = styled.div`
  width: 100%;

  margin-bottom: 32px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid;
`;

export const LabelName = styled.div`
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

export const Check = styled.img`
  width: 10px;
  height: 10px;
`;
